window.addEventListener('load', function () {
  const functionInit = () => {
    $('#openFilterMenu').click(function () {
      $('#mobile-collection-filters').attr('aria-hidden', false);
    });
    $('[data-action="close-drawer-new"]').click(function () {
      $('#mobile-collection-filters').attr('aria-hidden', true);
    });
  };
  const initDropdown = () => {
    const buttons = document.querySelectorAll('button-toggle');
    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const openedStatus = this.getAttribute('aria-expanded');
        if (openedStatus === 'false') {
          $('.collection__filter-collapsible').attr('aria-hidden', true);
          $('button-toggle').attr('aria-expanded', false);
        }
      });
    });
  };

  const hideAllDropdown = () => {
    // $('.collection__filter-collapsible').attr('aria-hidden', true);
    $('button-toggle').attr('aria-expanded', false);
  };

  initDropdown();

  functionInit();

  $('#desktop-filters-form').bind('DOMSubtreeModified', function () {
    setTimeout(function () {
      functionInit();
      initDropdown();
      hideAllDropdown();
      initVariantClick();
    }, 50);
  });
});
